module.exports = __webpack_public_path__ + "img/3_no.71302172.svg";